import { Layout, useSidebarState } from 'react-admin';
import { MyMenu } from '../MyMenu/MyMenu';
import { MyAppBar } from '../MyAppBar/MyAppBar';
import { makeStyles } from '@mui/styles';

import {
    AppLocationContext,
    ContainerLayout, Header
} from "@react-admin/ra-navigation";
import EmptyMenu from '../MyMenu/EmptyMenu';

const useStyles = makeStyles({
    sidebarClosed: {
        '&.RaSidebar-closed': {
            width: 0,
        },
    },
});

export const MyLayout = ({ children, ...props }) => {

    const classes = useStyles();
    const [open] = useSidebarState();

    return (
        <AppLocationContext hasDashboard>
            <Layout  {...props} menu={EmptyMenu} appBar={MyAppBar}
                sidebarOpen={false}
                classes={{
                    drawerPaper: open ? undefined : classes.sidebarClosed,
                }}
            >
                {children}
            </Layout>
        </AppLocationContext>
    );
}

